/**
 * Verificação de identidade por documento de foto (métodos IdDocument*).
 *
 * O frontend nunca fala com o provedor: pede à nossa API que abra uma sessão,
 * recebe uma URL, manda o signatário para lá e consulta o estado na volta.
 * Por isso nada aqui nomeia o provedor — o que muda entre provedores é só a URL.
 */

export const ID_DOCUMENT_FACE_MATCH_ADVANCED = 'IdDocumentFaceMatchAdvanced'
export const ID_DOCUMENT_FACE_MATCH_BASIC = 'IdDocumentFaceMatchBasic'
export const ID_DOCUMENT_FACE_MATCH_ADVANCED_AUTH = 'id_document_face_advanced'
export const ID_DOCUMENT_FACE_MATCH_BASIC_AUTH = 'id_document_face_basic'

export const IDENTITY_VERIFICATION_METHODS = [
  ID_DOCUMENT_FACE_MATCH_ADVANCED,
  ID_DOCUMENT_FACE_MATCH_BASIC,
]

/** verification_method da API → feature que a conta precisa ter liberada. */
export const IDENTITY_FEATURE_BY_METHOD = {
  [ID_DOCUMENT_FACE_MATCH_ADVANCED]: 'VerificationIdDocumentFaceMatchAdvanced',
  [ID_DOCUMENT_FACE_MATCH_BASIC]: 'VerificationIdDocumentFaceMatchBasic',
}

export function isIdentityVerificationMethod(method) {
  return IDENTITY_VERIFICATION_METHODS.includes(String(method || '').trim())
}

export function isIdentityAuthMethod(method) {
  return [ID_DOCUMENT_FACE_MATCH_ADVANCED_AUTH, ID_DOCUMENT_FACE_MATCH_BASIC_AUTH]
    .includes(String(method || '').trim())
}

/** Only Assinafy Verify (Basic) requires a valid CPF before sending. */
export function identityAuthMethodRequiresCpf(method) {
  return String(method || '').trim() === ID_DOCUMENT_FACE_MATCH_BASIC_AUTH
}

/** Identity authentication does not dictate how the invitation is delivered. */
export function notificationChannelAfterAuthChange(method, currentChannel = 'email') {
  if (isIdentityAuthMethod(method)) {
    return currentChannel === 'whatsapp' ? 'whatsapp' : 'email'
  }
  return method === 'whatsapp' ? 'whatsapp' : 'email'
}

/* Estados devolvidos por GET /signers/identity-verification. */
export const IDENTITY_STATUS = {
  PENDING: 'Pending',
  IN_REVIEW: 'InReview',
  APPROVED: 'Approved',
  DECLINED: 'Declined',
  EXPIRED: 'Expired',
  ABANDONED: 'Abandoned',
}

const IN_PROGRESS_STATUSES = [IDENTITY_STATUS.PENDING, IDENTITY_STATUS.IN_REVIEW]
const DEAD_END_STATUSES = [
  IDENTITY_STATUS.DECLINED,
  IDENTITY_STATUS.ABANDONED,
]

export function isIdentityInProgress(status) {
  return IN_PROGRESS_STATUSES.includes(String(status || '').trim())
}

export function isIdentityApproved(status) {
  return String(status || '').trim() === IDENTITY_STATUS.APPROVED
}

export function canContinueAfterIdentityVerification(status) {
  const normalized = String(status || '').trim()
  return normalized === IDENTITY_STATUS.APPROVED || normalized === IDENTITY_STATUS.IN_REVIEW
}

/**
 * Declined/Abandoned são finais. Expired fica de fora porque a API pode liberar
 * uma nova sessão para o mesmo signatário com can_start=true.
 */
export function isIdentityDeadEnd(status) {
  return DEAD_END_STATUSES.includes(String(status || '').trim())
}

/** Mensagem do beco sem saída — o signatário não tem como se resolver sozinho. */
export function identityDeadEndMessage(status) {
  switch (String(status || '').trim()) {
    case IDENTITY_STATUS.DECLINED:
      return 'Sua verificação não foi aprovada. Entre em contato com o remetente do documento.'
    case IDENTITY_STATUS.EXPIRED:
      return 'O prazo da sua verificação de identidade terminou.'
    case IDENTITY_STATUS.ABANDONED:
      return 'A verificação de identidade foi interrompida antes de ser concluída.'
    default:
      return 'A verificação de identidade não foi concluída.'
  }
}
